import { AreaChart, Area, LineChart as RLineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from 'recharts';
import { chartTokens, chartPalette, tooltipStyle, axisTick } from '@/components/charts/chartTheme';
import type { Series } from '@/components/charts/BarChart';

/** Themed line/area chart for time series. `area` fills under the line. */
export function LineChart<T extends object>({ data, xKey, series, height = 280, area = false }: {
  data: T[];
  xKey: string;
  series: Series[];
  height?: number;
  area?: boolean;
}) {
  const common = (
    <>
      <CartesianGrid strokeDasharray="3 3" stroke={chartTokens.grid} vertical={false} />
      <XAxis dataKey={xKey} tick={axisTick} axisLine={false} tickLine={false} />
      <YAxis tick={axisTick} axisLine={false} tickLine={false} />
      <Tooltip contentStyle={tooltipStyle} />
      {series.length > 1 && <Legend wrapperStyle={{ fontSize: 12, color: chartTokens.axis }} />}
    </>
  );

  return (
    <ResponsiveContainer width="100%" height={height}>
      {area ? (
        <AreaChart data={data}>
          {common}
          {series.map((s, i) => {
            const color = s.color ?? chartPalette[i % chartPalette.length];
            return <Area key={s.key} type="monotone" dataKey={s.key} name={s.name ?? s.key} stroke={color} fill={color} fillOpacity={0.15} strokeWidth={2} />;
          })}
        </AreaChart>
      ) : (
        <RLineChart data={data}>
          {common}
          {series.map((s, i) => (
            <Line key={s.key} type="monotone" dataKey={s.key} name={s.name ?? s.key} stroke={s.color ?? chartPalette[i % chartPalette.length]} strokeWidth={2} dot={false} />
          ))}
        </RLineChart>
      )}
    </ResponsiveContainer>
  );
}
